<div class="vd-gm-backdrop" (click)="close()">
  <div class="vd-gm" [attr.dir]="isRtl() ? 'rtl' : 'ltr'" (click)="$event.stopPropagation()"
       role="dialog" aria-modal="true" [attr.aria-label]="variant()?.title">

    <header class="vd-gm-head">
      <div class="vd-gm-title">
        <span class="material-icons-outlined">school</span>
        <div>
          <strong>{{ variant()?.title }}</strong>
          <small>{{ variant()?.description }}</small>
        </div>
      </div>

      <div class="vd-gm-tools">
        <div class="vd-gm-locales" role="group" [attr.aria-label]="'guide.language' | transloco">
          <button *ngFor="let l of availableLocales" [class.on]="l === locale()"
                  (click)="switchLocale(l)">{{ localeLabel(l) }}</button>
        </div>
        <div class="vd-gm-rates" role="group" [attr.aria-label]="'guide.speed' | transloco">
          <button *ngFor="let r of rates" [class.on]="r === rate()" (click)="setRate(r)">
            {{ r }}×
          </button>
        </div>
        <button class="vd-gm-close" (click)="close()" [attr.aria-label]="'guide.close' | transloco">
          <span class="material-icons-outlined">close</span>
        </button>
      </div>
    </header>

    <div class="vd-gm-body" *ngIf="variant() as v">
      <div class="vd-gm-player">
        <video #player controls autoplay playsinline
               [poster]="v.poster" (timeupdate)="onTimeUpdate()" (ended)="onTimeUpdate()"
               crossorigin="anonymous">
          <source [src]="v.video" type="video/mp4" />
          <track kind="subtitles" [src]="v.vtt" [srclang]="locale()" default />
        </video>
      </div>

      <aside class="vd-gm-chapters" [attr.aria-label]="'guide.chapters' | transloco">
        <h4>{{ 'guide.chapters' | transloco }}</h4>
        <button *ngFor="let c of v.chapters; index as i"
                class="vd-gm-chapter"
                [class.active]="isActiveChapter(c.start, c.duration)"
                (click)="seek(c.start)">
          <span class="vd-gm-chap-num">{{ i + 1 }}</span>
          <span class="vd-gm-chap-title">{{ c.title }}</span>
          <span class="vd-gm-chap-time">{{ fmt(c.start) }}</span>
        </button>
      </aside>
    </div>
  </div>
</div>
